module.exports = __webpack_public_path__ + "img/slot.6a8e1234.png";